import React from 'react';
import NameAndNumber from '../../../types/report/NameAndNumber';
import { ReactComponent as SearchIcon } from '../../Common/BootstrapIcons/search.svg';
import { ReactComponent as ClearIcon } from '../../Common/BootstrapIcons/close.svg';
import CustomIcon from '../BootstrapIcons/Custom/CustomIcon';
import iconTooltip from '../BootstrapIcons/Tooltip/IconTooltip';
import './styles.scss';
import { generateKey } from '../../../infrastructure/helpers/react/commonHelper';
interface Props {
    onSearch: (options: NameAndNumber[], searchBy: string) => void;
    label: string;
    onClearClick: () => void;
    onSearchByChange: (value: string) => void;
    searchByOptions: string[];
    getOptions: () => NameAndNumber[];
}

interface State {
    value: string;
    matchedOptions: NameAndNumber[];
    showMatches: boolean;
    searchBy: string;
}

class AutocompleteInput extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            value: '',
            matchedOptions: [],
            showMatches: false,
            searchBy: this.props.searchByOptions?.[0] || ''
        }

        this.onChange = this.onChange.bind(this);
        this.onOptionSelected = this.onOptionSelected.bind(this);
        this.onInputClick = this.onInputClick.bind(this);
    }

    onChange(e: any) {

        let matchedOptions = this.tryMatch(e.target.value);

        this.setState({ value: e.target.value, matchedOptions, showMatches: matchedOptions.length > 0 });
    }

    tryMatch(value: string): NameAndNumber[] {

        let resultOptions: NameAndNumber[] = [];

        this.props.getOptions().forEach(x => {
            let words = x.name.split(' ');

            let match = words.find(x => x.toLowerCase().indexOf(value.toLowerCase()) > -1);

            if (match) {
                resultOptions.push(x);
            }
        });

        return resultOptions;
    }

    onOptionSelected(option: NameAndNumber) {
        this.setState({ value: option.name, showMatches: false }, () => { this.props.onSearch([option], this.state.searchBy); });
    }

    onSearchClick(value: string) {

        this.setState({ showMatches: false });

        let options = this.tryMatch(value);

        this.props.onSearch(options, this.state.searchBy);
    }

    onInputClick(e: React.MouseEvent<HTMLInputElement>) {
        this.props.getOptions()
    }

    render(): JSX.Element {
        return (
            <>
                <div className='margin-left-10px display-flex width-100-percents'>
                    <div className='autocomplete' >
                        <select value={this.state.searchBy}
                            onChange={(e) => { this.setState({ searchBy: e.target.value }); this.props.onSearchByChange(e.target.value); }}>
                            {this.props.searchByOptions.map((x) => {
                                return <option key={generateKey()} value={x}>{`Search by ${x}`}</option>
                            })
                            }
                        </select>
                        <div className='input-container'>
                            <input autoComplete='off'
                                className='input-field'
                                value={this.state.value}
                                type='text'
                                onChange={this.onChange}
                                onKeyDown={e => e.key === 'Enter' && this.onSearchClick(this.state.value)}
                                onClick={this.onInputClick}
                                name={`${this.props.label}`} />
                        </div>
                    </div>
                    <button className='custom-icon-button autocomplete-button' onClick={() => this.onSearchClick(this.state.value)}>
                        <CustomIcon icon={SearchIcon} title={iconTooltip.search} />
                    </button>
                    <button className='custom-icon-button autocomplete-button' onClick={() => this.setState({ value: '', showMatches: false }, () => this.props.onClearClick())}>
                        <CustomIcon icon={ClearIcon} title={iconTooltip.clear} />
                    </button>
                </div>
                {
                    this.state.showMatches &&
                    <ul className='results'>
                        {this.state.matchedOptions.map(x => {
                            return <li key={generateKey()} onClick={() => this.onOptionSelected(x)}>{x.name}</li>
                        })
                        }
                    </ul>
                }
            </>
        )
    }
}

export default AutocompleteInput;